import React from "react";
import "./HomeGraphicCards.css";

const cards = [
  {
    title: "Find Local Support",
    description: "Find trusted local support options near you.",
    href: "/resource-search",
    type: "search",
    image: "/assets/images/icon/Helping.svg",
  },
  {
    title: "Explore Content",
    description: "Browse videos, audio, articles, and practical wellness resources.",
    href: "/content",
    type: "content",
    image: "/assets/images/icon/Content.svg",
  },

  {
    title: "Quick Reset",
    description: "Try a short grounding or self-care exercise when you need a reset.",
    href: "/micro-exercises",
    type: "capsules",
    image: "/assets/images/icon/capsule.svg",
  },
  {
    title: "Build Your Plan",
    description: "Get personalized recommendations and start a self-care plan.",
    href: "/interests-page",
    type: "actionplan",
    image: "/assets/images/icon/YogaDog.svg",
  },
  {
    title: "Community",
    description: "Join supportive spaces with people who may understand.",
    href: "/community",
    type: "community",
    image: "/assets/images/icon/friendships.svg",
  },
];

function CardGraphic({ type }) {
  // if (type === "search") {
  //   return (
  //     <div className="hvc-graphic hvc-graphic-search">
  //       <svg width="170" height="120" viewBox="0 0 170 120" fill="none">
  //         <rect x="18" y="30" width="92" height="58" rx="10" fill="white" />
  //         <rect x="34" y="45" width="52" height="7" rx="4" fill="#D9C7EA" />
  //         <rect x="34" y="60" width="40" height="7" rx="4" fill="#D9C7EA" />
  //         <rect x="34" y="75" width="30" height="7" rx="4" fill="#D9C7EA" />
  //         <circle cx="112" cy="58" r="32" stroke="#5A3B7A" strokeWidth="10" />
  //         <rect
  //           x="135"
  //           y="82"
  //           width="45"
  //           height="10"
  //           rx="5"
  //           transform="rotate(45 135 82)"
  //           fill="#5A3B7A"
  //         />
  //       </svg>
  //     </div>
  //   );
  // }

  // if (type === "content") {
  //   return (
  //     <div className="hvc-graphic hvc-graphic-content">
  //       <svg width="170" height="120" viewBox="0 0 170 120" fill="none">
  //         <rect x="24" y="28" width="122" height="68" rx="12" fill="#10202B" />
  //         <circle cx="85" cy="58" r="23" fill="#E74779" />
  //         <path d="M79 47L99 58L79 70V47Z" fill="white" />
  //         <rect x="45" y="80" width="80" height="5" rx="3" fill="#4B5B65" />
  //         <rect x="45" y="80" width="36" height="5" rx="3" fill="#E74779" />
  //       </svg>
  //     </div>
  //   );
  // }

  // if (type === "community") {
  //   return (
  //     <div className="hvc-graphic hvc-graphic-community">
  //       <svg width="190" height="130" viewBox="0 0 190 130" fill="none">
  //         <circle cx="55" cy="42" r="18" fill="#E9A389" />
  //         <path d="M38 68C38 55 72 55 72 68V104C72 116 38 116 38 104V68Z" fill="#EC4E7C" />
  //         <path d="M40 35C42 22 58 20 67 31C57 27 47 29 40 35Z" fill="#17212B" />
  //         <path d="M36 58C27 51 25 41 30 33" stroke="#17212B" strokeWidth="5" strokeLinecap="round" />

  //         <circle cx="95" cy="35" r="20" fill="#C87D61" />
  //         <path d="M74 65C74 49 116 49 116 65V108C116 123 74 123 74 108V65Z" fill="#F36B21" />
  //         <path d="M77 30C83 15 104 14 113 29C101 23 88 23 77 30Z" fill="#17212B" />

  //         <circle cx="137" cy="42" r="18" fill="#8A4D3A" />
  //         <path d="M120 69C120 55 154 55 154 69V104C154 116 120 116 120 104V69Z" fill="#3F8FD2" />
  //         <path d="M121 38C125 25 142 22 153 34C141 29 130 30 121 38Z" fill="#17212B" />

  //         <circle cx="50" cy="43" r="2" fill="#17212B" />
  //         <circle cx="61" cy="43" r="2" fill="#17212B" />
  //         <path d="M51 52C55 56 60 56 64 52" stroke="#17212B" strokeWidth="2" strokeLinecap="round" />

  //         <circle cx="89" cy="36" r="2" fill="#17212B" />
  //         <circle cx="101" cy="36" r="2" fill="#17212B" />
  //         <path d="M89 46C94 50 101 50 105 46" stroke="#17212B" strokeWidth="2" strokeLinecap="round" />

  //         <circle cx="132" cy="43" r="2" fill="#17212B" />
  //         <circle cx="143" cy="43" r="2" fill="#17212B" />
  //         <path d="M133 52C137 56 143 56 147 52" stroke="#17212B" strokeWidth="2" strokeLinecap="round" />
  //       </svg>
  //     </div>
  //   );
  // }

  // if (type === "books") {
  //   return (
  //     <div className="hvc-graphic hvc-graphic-books">
  //       <svg width="190" height="130" viewBox="0 0 190 130" fill="none">
  //         <rect x="28" y="40" width="22" height="65" rx="5" fill="#FF9A64" />
  //         <rect x="55" y="25" width="25" height="80" rx="5" fill="#F36B21" />
  //         <rect x="85" y="36" width="24" height="69" rx="5" fill="#E45745" />
  //         <rect x="115" y="20" width="28" height="85" rx="5" fill="#17212B" />

  //         <rect x="154" y="78" width="32" height="30" rx="0" fill="#F5C29D" />
  //         <path d="M150 76C141 62 126 65 122 70C135 76 143 78 150 76Z" fill="#5A3B7A" />
  //         <path d="M174 76C183 62 198 65 202 70C189 76 181 78 174 76Z" fill="#5A3B7A" />
  //         <path d="M154 78H186V104C186 114 154 114 154 104V78Z" fill="#F5C29D" />
  //       </svg>
  //     </div>
  //   );
  // }

  return null;
}

export default function HomeGraphicCards() {
  return (
    <section className="hvc-section">
      <div className="container">
        <div className="hgc-panel">
          <div className="hgc-heading">
            <span className="hgc-pill">Not sure where to start?</span>
            <h2>How would you like Helprr to help you today?</h2>
            <p>Choose what feels closest to what you need right now.</p>
          </div>

          <div className="hvc-grid">
            {cards.map((card) => (
              <a
                href={card.href}
                className={`hvc-card hvc-card-${card.type}`}
                key={card.title}
              >
                {card.image ? (
                  <div className={`hvc-graphic hvc-graphic-${card.type}`}>
                    <img
                      src={process.env.PUBLIC_URL + card.image}
                      alt={card.title}
                      className="hvc-graphic-img"
                    />
                  </div>
                ) : (
                  <CardGraphic type={card.type} />
                )}

                <div className="hvc-card-body">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>

                <span className="hvc-arrow">→</span>
              </a>
            ))}
          </div>

          <p className="hgc-trust-note">
            Private, judgment-free support. Helprr is not a crisis service or replacement for therapy.
          </p>
        </div>
      </div>
    </section>
  );
}